import { find } from 'rambda'

import type { NodeTypes } from '../types'
import {
    ActionDataNodeType,
    AINodeType,
    FlowControlNodeType,
    type FlowEdge,
    type FlowNode,
    OtherPlatformNodeType,
    TriggerNodeType
} from '../types'

export const getParentNodeIds = (currentNodeId: string, edges: FlowEdge[], parentNodes: string[]) => {
    const parents = edges.filter(item => item.target === currentNodeId)
    if (parents.length === 0) {
        return
    }
    parents.forEach(item => {
        if (parentNodes.includes(item.source)) {
            return
        }
        parentNodes.push(item.source)
        getParentNodeIds(item.source, edges, parentNodes)
    })

    return parentNodes
}

export const getAllParentNodes = (nodeId: string, nodes: FlowNode[], edges: FlowEdge[]) => {
    const nodeIds = getParentNodeIds(nodeId, edges, [])
    if (!nodeIds) {
        return []
    }
    return nodeIds.reverse().reduce<FlowNode[]>((prev, cur) => {
        const node = find(node => node.id === cur, nodes)
        if (node) {
            prev.push(node)
        }
        return prev
    }, [])
}

export const canBeUpstreamNodeTypes = new Set<NodeTypes>([
    /** 动作流 */
    TriggerNodeType.CLICK_TRIGGER,
    TriggerNodeType.WEBSOCKET_TRIGGER,
    /** 自动化 */
    TriggerNodeType.CREATE_RECORD_TRIGGER,
    TriggerNodeType.MATCH_CONDITION_TRIGGER,
    TriggerNodeType.UPDATE_RECORD_TRIGGER,
    TriggerNodeType.ARG_TRIGGER,
    TriggerNodeType.WEBHOOK_TRIGGER,
    ActionDataNodeType.FIND_RECORD_ACTION,
    ActionDataNodeType.CREATE_RECORD_ACTION,
    /** 共有 */
    ActionDataNodeType.CREATE_SINGLE_RECORD_ACTION,
    ActionDataNodeType.UPDATE_RECORD_ACTION,
    ActionDataNodeType.FIND_SINGLE_RECORD_ACTION,
    ActionDataNodeType.IMPORT_EXCEL,
    AINodeType.CODE_ACTION,
    AINodeType.LLM_ACTION,
    AINodeType.PARAM_EXTRACT_ACTION,
    OtherPlatformNodeType.GOOGLE_SEARCH_ACTION,
    OtherPlatformNodeType.BAIDU_SEARCH_ACTION,
    OtherPlatformNodeType.BING_SEARCH_ACTION,
    OtherPlatformNodeType.WECHAT_UPLOAD_SHIPPING_INFO,
    OtherPlatformNodeType.WECHAT_GET_ORDER_SHIPPING,
    OtherPlatformNodeType.WECHAT_GET_ORDER_LIST,
    OtherPlatformNodeType.WECHAT_FOLLOW_WAYBILL,
    FlowControlNodeType.HANDLE_SUB_PROCESS
])
export const getAllCanBeUpstreamNodes = (allParentNodes: FlowNode[]) => {
    return allParentNodes.filter(node => {
        return canBeUpstreamNodeTypes.has(node.data.nodeType)
    })
}
